import { FaqdataProps } from "../interfaces/interfaces.d";

export const faqData: Array<FaqdataProps> = [
  {
    id: 1,
    title: "What is Bonpellz",
    content: ` bonpellz is a financial super app that enables you save responsibly and make well meaning investment, you get to enjoy 
              great interest & massive incentive on your savings and best returns on your investments.`,
  },
  {
    id: 2,
    title: "Why save with Bonpellz",
    content: `<ul>
                  <li>it is the smartest platform to help you understand money concept,
                      manage your finances, save responsibly and make well meaning
                      investments.
                  </li>
                  <li>
                     as a parent, it is the finest journey to proactively achieve financial freedom for your child.
                  </li>
                  <li> it helps you maintain a savings discipline either for a short or a
                      longer period of time with a stress-free automated system.
                  </li>
                  <li>
                    with us all your dream target goals are easily achieved as you will
                    never miss out on your savings and investment targets anymore.
                  </li>
              </ul>`,
  },
  {
    id: 3,
    title: "BVN",
    content: `the reason you should submit your Bvn to us is simply because we need it to verify your identity in order to protect
    your account against theft and impersonation, your Bvn does not provide access to your bank account, so your account is very much safe with us.
    `,
  },
  {
    id: 4,
    title: "Acct No and Debit Card",
    content: `<ul>
                <li>on our platform you can use any account number from any
                bank of your choice in Nigeria and your account number is only
                required for your withdrawals.
                </li>
                <li>we accepts all Nigerian banks debit cards.</li>
            </ul>`,
  },
  {
    id: 5,
    title: "SP PIN (Hexa virtual account)",
    content: `this is the 6 Unique PIN created for all bonpellz users with which
              they activate their desired savings plan.`,
  },
];

export const faqDataSavings: Array<FaqdataProps> = [
  {
    id: 1,
    title: "Must I always login to save funds?",
    content: ` you do not need to login always if you have activated your Plan
                and set your target goals, savings are done automatically unless
                you put on pause the Cybernate button or want to top-up your
                savings then you will have to login.`,
  },
  {
    id: 2,
    title: "How much can I save on Bonpellz",
    content: `the minimum amount you can safe on bonpellz is #100 and we
              only have an upper limit on the basic savings plan, the rest of
              our savings plan have no upper limit you can save as much as
              possible with us. `,
  },
  {
    id: 3,
    title: "What types of savings plan are available on Bonpellz",
    content: `<ul>
                  <li>Basic</li>
                  <li>Level Up</li>
                  <li>Special savers.</li>
                  <li>Special champions</li>
                  <li>Special legends</li>
                  <li>Group savings Achievements.</li>
                  <li>Go to Smart savings on the home page to <a href="/">learn more</a></li>
              </ul>`,
  },
  {
    id: 4,
    title: "How long can I keep my Savings",
    content: `we have a minimum period of 15 days and our maximum
              periods are also expandable, in other words you can keep your
              savings with us for as long as you want even as you enjoy great
              interest and massive incentive on your savings.`,
  },
  {
    id: 5,
    title: "What interest rate do I enjoy on my plans",
    content: `on basic and level up savings plan, parents/children are
            massively incentivized while on other plans you get 5% - 15% p.a
            depending on the duration of your target savings.`,
  },
  {
    id: 6,
    title: "Can I increase my Savings whenever I want?",
    content: `of course, you can always!	Just login and go to the savings plan you would like to increase your savings click on the sub savings plan, then click on the settings option, set your new amount and  frequency.
              <ul>
              <li>  What happens if I do not have funds in my debit card
                    account at a particular day, week, fortnight or month
              </li>
              </ul>
              <p>   its fine that means you have simply stopped your savings for that period because we can only save for you automatically when you have funds on your debit card, nevertheless you can make use of the speedy keep to save fund when you have it. For parents on Basic and Level up S.P you can make use of your credit money (Overdraft) option or speedy keep too.
               </p>`,
  },
  {
    id: 7,
    title: "Speedy keep",
    content: `this enables you to keep up with your target savings, with the speedy keep you can add more money to your savings and also pay for the day, week, fortnight or month you skipped and even pay ahead of your regular savings`,
  },
  {
    id: 8,
    title: "Can someone activate a Savings plan for me",
    content: `yes! A savings plan can be activated for you by another
             bonpellz user.`,
  },
  {
    id: 9,
    title: "How do I activate a Savings plan for someone",
    content: `<p>you go to your savings plan either the special champions or legends then 
    click on the “benefit for” option put the beneficiary pin then activate the savings plan 
    of the beneficiary by clicking on the Activate S.P .
            </p>
            <p>
                Note; the beneficiary will need to have Initiated his/her special
                champions/legends savings plan to effect the activation.
            </p>
            `,
  },
  {
    id: 10,
    title: "How do I add a beneficiary on my Savings plan",
    content: `<p>you go to your special champions/legends savings plan then
              click on the “benefit for’’ option, input the beneficiary pin into
              the add beneficiary space.</p>
              <p>Note; the beneficiary will need to have Activated his/her
              special champions/legends savings plan to effect any benefit
              off the benefactor.
            </p>`,
  },
  {
    id: 11,
    title: "How do I benefit off someone on Special Legends S.P",
    content: `you go to your special legends savings plan then click on the “benefit off “Option then input the benefactors pin and click on send, the benefactor get immediately an acceptance message, if he/she accepts then you are added as a beneficiary on his account automatically and a benefits off him/her is effected.
    `,
  },
  {
    id: 12,
    title: "How do I remove a beneficiary on special champions/legends S.P",
    content: `simple! Just go to your special champion/legends savings plan click on the
            “benefits for’’ option, the beneficiary’s list displays then you click on the pin of the
            beneficiary you want to remove and click on remove beneficiary.`,
  },
  {
    id: 13,
    title: "Can I deactivate/liquidate my plans",
    content: `<p> yes! on our app home page, go to the quick access and click on manage plans, choose either to Deactivate or Liquidate, if Liquidate, click on the liquidate option, next is the liquidate S.P and liquidate I.P option,  you click on your preferred option and it takes you to the plan you want to liquidate, click on the plan to liquidate</p>
              <p>Note; liquidation is only for the parents on Basic and Level up
              savings plan. Parents needs to notify bonpellz 3months prior to
              liquidation i.e your liquidation will be successful after 3months
              of the request.
            </p>
            <p>
                other bonpellz users can deactivate S.P at any given time.
            </p>`,
  },
  {
    id: 14,
    title: "Can I pause my plans",
    content: `yes! you can, all you need to do is login, go to the savings plan
              you want to pause and turn off the Cybernate button however
              you can continue later by turning on the Cybernate or fund
              your savings plan manually with the speedy keep.`,
  },
  {
    id: 15,
    title: "Can I monitor my Savings and returns",
    content: `yes! You can as all transaction on savings and investment are
              visible on your dashboard.`,
  },
  {
    id: 16,
    title:
      "What’s the maximum number of children I can add on the Basic and Level up S.P",
    content: `you can add a maximum of 5 children on each of the sub plan just make sure to
            register their details separately on CID for easy tracking, go to menu to learn more about
            CID`,
  },
  {
    id: 17,
    title:
      "What if I have a God daughter/son or ward that’s a child, teenager can I still register such",
    content: `yes! You can just make sure to register such child on the CID for easy tracking and note; you only have a maximum of 5 slot to add any more child.`,
  },
  {
    id: 18,
    title: "Is the account creation available on the app",
    content: `yes! The account creation is available on the app all you need to do is download, launch the app and follow the process.`,
  },
];

export const faqDataInvestment: Array<FaqdataProps> = [
  {
    id: 1,
    title: "What types of investment are available on Bonpellz?",
    content: `<ul>
                  <li>Mini investment</li>
                  <li>Cardinal investment</li>
                  <li>Foreign investment</li>
                  <li>Go to Sublime investment on the home page to <a href="/">learn more.</a></li>
              </ul>`,
  },
  {
    id: 2,
    title: "How safe is my investment?",
    content: `very safe! we make sure that each investment opportunities enlisted on
              each stages of our investment plan comes with a protection and security
              in the form of insurance against loss.`,
  },
  {
    id: 3,
    title: "How much can I invest?",
    content: `the amount you can invest differs with the variety of investment listing
              on our platform.`,
  },
  {
    id: 4,
    title: "How do I fund my Investment?",
    content: `your investment can either be funded through the debit card or Bzpool`,
  },
  {
    id: 5,
    title: "Is my capital protected against failed investment?",
    content: `yes! all investment opportunities on our platform are scrutinized to
            ensure maximum protection against capital loss but returns may be lost.`,
  },
  {
    id: 6,
    title: "What returns do I get and how do I get paid?",
    content: `returns varies with the choice of the Investment opportunity you
            engaged at any stages of our investment plan, from 10% - 40% and your
            returns could be paid on a monthly basis or at maturity date into your Bz
            pool depending on your choice of investment.`,
  },
  {
    id: 7,
    title: "Is my investment liquidatable and how do I liquidate?",
    content: `yes! It is liquidatable but to liquidate you will have to sell the units you
            have already acquired to a new potential investor or existing one.`,
  },
  {
    id: 8,
    title: "Bzpool",
    content: `this is a fund account on our platform for you. it receives fund transfer,
              your investment returns and your earnings, funds here can be transferred
              to another bonpellz user, a third party, into your Savings and Investment
              plans.`,
  },
  
];

export const faqDataSafetySecurity: Array<FaqdataProps> = [
  {
    id: 1,
    title: "How safe is my information with Bonpellz",
    content: ` the highest level security measure is been used to keep your information save as your data is encrypted and Securely stored with a PCIDSS compliant payment processor that handles your card details and every dealings on our website and app is through an encrypted 256 bits HTTP SSL connections all to ensure maximum protections of your data against any form of fraud.`,
  },
  {
    id: 2,
    title: "How safe is my money",
    content: `we work in partnership with a bank, all funds are held, monitored and managed by our partner bank (a wealth management group of company)
              all Investment listings are smartly on low risk investment opportunities that comes with maximum protection against loss  i.e all listings are insured.
              <p>Contact: 08051003534</p>
              <p>Email: <span style={{color:'blue'}}>Info@bonpellz.com</span></p>
              `,
  },
];

export const faqDataWithdrawals: Array<FaqdataProps> = [
  {
    id: 1,
    title: "Withdrawals",
    content: `<ul>
                <li>parents who opted for the Bonpellz Ultimate goal on Basic and Level up can only withdraw at the Plan due dates or otherwise liquidate which comes at a cost of 2% fine of their savings and must be foretold at least 3 Months before the decision i.e your Liquidation will be successful after 3months of the request.</li>
                <li>parent may decide to rollover funds from one withdrawal stage to another for the Bonpellz ultimate goal.</li>
                <li>customer on Special savers can only withdraw freely at the Free maturity dates, breaking funds out of this date will attract 2.5% fine of your savings all for a discipline purpose.</li>
                <li>customers on the main Special champions and legends Sub Savings plan can only withdraw freely at the maturity date or if target is hit but on the other sub plan, breaking of fund is allowed at a cost of 2% and withdrawal date can be expanded by the Customer.</li>
            </ul>`,
  },
  {
    id: 2,
    title: "How will I withdraw my money",
    content: `<ol>
                <li>you will have to login on our app</li>
                <li>go to “Withdraw” on the home page</li>
                <li>click on withdraw to go to the Savings plan click on the sub plan</li>
                <li>you would like to withdraw from</li>
                <li>enter the amount you would like to withdraw.</li>
                <li>enter password</li>
                <li>then click on withdraw</li>
            </ol>`,
  },
  {
    id: 3,
    title: "Fees and Charges",
    content: `<ul>
                <li>no charges</li>
                <li>zero maintenance fee</li>
                <li>no transfer charges</li>
            </ul>`,
  },
  {
    id: 4,
    title: "Mobile app available?",
    content: `<ul>
                <li>coming soon to both</li>
                <li>app store and google store</li>
            </ul>`,
  },
];
